import * as React from 'react'
import { Button } from '~/components/_atoms/index'
import { useTranslation } from '~/hooks/useTranslation'

export function ViewCell({ row, table }) {
  const chat = row.original
  const { t } = useTranslation()

  const setSelectedChat = table.options.meta?.setSelectedChat

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <Button variant="link" onClick={() => setSelectedChat(chat)}>
          {t('chat_histories.view')}
        </Button>
      </div>
    </div>
  )
}
